import * as THREE from "three";
import { useRef, useEffect } from 'react'
import { useGLTF } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { MeshBasicMaterial } from "three";


export default function ChairHigh(props) {

  const chairHighPositions = [
    [5.49811, 0.494329, -0.03029, 0],
    [5.49811, 0.494329, 0.528975, 0],
    [5.49811, 0.494329, 1.09337, 0],
    [5.49811, 0.494329, 1.65672, 0],
    [5.49811, 0.494329, 2.21286, 0],
    [5.49811, 0.494329, 2.77619, 0],
    [4.20431, 0.494329, 2.0414, -0.05555],
    [2.7776, 0.494329, 2.02334, -0.945],
    [3.78642, 0.494329, 0.687478, -0.6],
    [3.79927, 0.494329, -0.722865, 0.6],
    [-4.09551, 0.494329, -2.10032, 1],
  ];

    const ref = useRef()
    const temp = new THREE.Object3D()
    useEffect(() => {
      // Set positions
      for (let i = 0; i < chairHighPositions.length; i++) {
        temp.position.set(chairHighPositions[i][0], chairHighPositions[i][1], chairHighPositions[i][2])
        temp.rotation.set(0, chairHighPositions[i][3] * Math.PI, 0)
        temp.updateMatrix()
        ref.current.setMatrixAt(i, temp.matrix)
      }
      // Update the instance
      ref.current.instanceMatrix.needsUpdate = true
    }, [chairHighPositions])
    const { nodes } = useGLTF("models/chairHigh.glb");
    const [texture] = useLoader(TextureLoader, ["textures/" + (props.isMobile ? "Textures_Quarter/" : "") + "Chairs_High_Bake1_CyclesBake_COMBINED_ergebnis.webp",
    ]);
  
    texture.flipY = false;
    texture.colorSpace = THREE.SRGBColorSpace;
    const Material = new MeshBasicMaterial();
    Material.map = texture;
    Material.toneMapped = false;
    Material.needsUpdate = true;
    
  return(
      <instancedMesh ref={ref} args={[nodes.Chairs_High_Baked.geometry, Material, chairHighPositions.length]}/>
    )
  }

  useGLTF.preload("models/chairHigh.glb");